import { Component } from '@angular/core';
import { SedsModalAbstractComponent } from 'experian-design-system';

@Component({
    selector: 'pl-export-modal',
    templateUrl: './export-modal.component.html',
    styleUrls: ['./export-modal.component.scss'],
    standalone: false
})
export class ExportModalComponent extends SedsModalAbstractComponent {
  public title = 'Lista de acessos em processamento';

  constructor() {
    super();
  }

  cancel(): void {
    this.close('cancelled');
  }

  confirm(): void {
    this.close('confirmed');
  }
}

